import { useSelector } from 'react-redux';
import useQuickDeposit from '../components/payment/hooks/use-quick-deposit';
import selectGlobalQuickDepositEnabled from '../components/header/ducks';
import { QDType } from '../components/payment/util/constants';

const useGlobalQuickDeposit = (shouldRefreshOnInit: boolean): { isQuickDepositAvailable: boolean } => {
	const isQuickDepositEnabled = useSelector(selectGlobalQuickDepositEnabled);
	return useQuickDeposit({ isEnabled: isQuickDepositEnabled, shouldRefreshOnInit, type: QDType.global });
};

export default useGlobalQuickDeposit;
